import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { Button, message } from 'antd'
import RichTextEditor from 'react-rte'
import styled from 'styled-components'
import { actions } from '../../redux/modules/templatesActions'
import { actions as itemActions } from '../../redux/modules/jobFunctions/itemActions'
import { actions as contractActions } from '../../redux/modules/contractActions'
import ContractTemplatePreview from '../../components/templates/ContractTemplatePreview'
import ContractTemplateForm from '../../components/templates/ContractTemplateForm'
import _ from 'lodash'
import config from '../../config'

const { API_BASE } = config

const Container = styled.div`
  padding: 25px;
`

const propTypes = {}

class TemplatesContract extends Component {
  constructor(props) {
    super(props)
    this.state = {
      currentKey: 'contract',
      currentId: +this.props.match.params.templateId,
      workByOthers: RichTextEditor.createEmptyValue(),
      terms: RichTextEditor.createEmptyValue(),
      header: RichTextEditor.createEmptyValue(),
      footer: RichTextEditor.createEmptyValue(),
      preview: +this.props.match.params.templateId ? true : false
    }
  }

  componentWillMount() {
    const { currentId } = this.state
    this.props.getTemplateById({
      templateType: this.state.currentKey,
      templateId: currentId
    })
    this.props.getAllItems()
    this.props.getContractPaymentScheduleTemplate({ templateId: currentId })
  }

  componentDidUpdate(prevProps) {
    if (this.props.templatesActions && this.props.templatesActions.loadedTemplate) {
      if (
        this.props.templatesActions.loadedTemplate !== prevProps.templatesActions.loadedTemplate
      ) {
        const loadedTemplate = this.props.templatesActions.loadedTemplate.data[0]
        if (loadedTemplate) {
          this.setState({
            ...loadedTemplate,
            templateName: loadedTemplate.name,
            templateDescription: loadedTemplate.description,
            workByOthers: RichTextEditor.createValueFromString(
              loadedTemplate.work_by_others,
              'html'
            ),
            terms: RichTextEditor.createValueFromString(loadedTemplate.terms, 'html'),
            header: RichTextEditor.createValueFromString(loadedTemplate.header, 'html'),
            footer: RichTextEditor.createValueFromString(loadedTemplate.footer, 'html')
          })
        }
      }
    }
  }

  handleInputChange = (value, input) => {
    this.setState({ [input]: value })
  }

  handleCreate = paymentSchedule => {
    const {
      templateName,
      templateDescription,
      workByOthers,
      terms,
      header,
      footer,
      currentId
    } = this.state
    const data = {
      work_by_others: workByOthers.toString('html'),
      terms: terms.toString('html'),
      header: header.toString('html'),
      footer: footer.toString('html'),
      description: templateDescription,
      name: templateName,
      estimate_template_id: currentId
    }
    if (currentId === 0) {
      this.props.createTemplate({
        templateType: 'contract',
        content: data,
        paymentSchedule,
        userId: this.props.authentication.user.userId
      })
    } else {
      this.props.saveTemplate({
        templateId: this.state.currentId,
        templateType: 'contract',
        content: data,
        paymentSchedule,
        userId: this.props.authentication.user.userId
      })
    }

    message.success('Changes saved.')
    this.setState({ contentData: null, currentId: 0, modalVisible: false })
  }

  confirmDelete = () => {
    this.props.deleteTemplate({
      templateId: this.state.currentId,
      templateType: 'contract'
    })

    message.success('Record deleted.')
    this.setState({
      contentData: null,
      currentId: 0,
      modalVisible: false
    })
  }

  togglePreview = () => {
    this.setState({
      preview: !this.state.preview
    })
  }

  render() {
    const { preview } = this.state
    const paymentScheduleDataStructure = _.get(
      this.props,
      'contractActions.contractPaymentScheduleTemplate.data'
    )
    if (this.props.templatesActions && this.props.templatesActions.loadingTemplate) {
      return (
        <div>
          <i className="fa fa-refresh fa-spin fa-3x fa-fw" />
          <span className="sr-only">Loading...</span>
        </div>
      )
    } else {
      return (
        <Container>
          <h2>Contract Template</h2>
          <div className="row">
            <div className="col-3">
              <Button icon={preview ? 'edit' : 'bars'} onClick={() => this.togglePreview()}>
                {preview ? 'Edit Details and Payment Schedule' : 'Back to Preview'}
              </Button>
            </div>
            {this.state.currentId !== 0 && (
              <div className="col-3">
                <a
                  target="_blank"
                  href={`${API_BASE}/api/templates/contract/id/${this.state.currentId}/print`}
                >
                  <Button icon="printer">Print contract template</Button>
                </a>
              </div>
            )}
          </div>
          {preview && (
            <ContractTemplatePreview
              {...this.state}
              confirmDelete={this.confirmDelete}
              paymentScheduleDataStructure={paymentScheduleDataStructure}
            />
          )}
          {!preview && (
            <ContractTemplateForm
              handleInputChange={this.handleInputChange}
              onCreate={this.handleCreate}
              confirmDelete={this.confirmDelete}
              paymentScheduleDataStructure={paymentScheduleDataStructure}
              {...this.state}
            />
          )}
        </Container>
      )
    }
  }
}

const mapStateToProps = (
  { templatesActions, itemActions, authentication, contractActions },
  ownProps
) => ({
  templatesActions,
  itemActions,
  authentication,
  contractActions
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(Object.assign({}, actions, itemActions, contractActions), dispatch)
})

TemplatesContract.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TemplatesContract))



// WEBPACK FOOTER //
// ./src/containers/templates/contractTemplate.js